import { generateFluidTypeUtils, generateTypographyUtils } from '../generators';

export const font = {
  ...generateTypographyUtils(),

  fluid: generateFluidTypeUtils(),
};
